import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-precio-modificacion',
  templateUrl: './precio-modificacion.component.html',
  styleUrls: ['./precio-modificacion.component.scss']
})
export class PrecioModificacionComponent implements OnInit {

  isLoading = false;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/modificacion-precio/precio-modificacion/precio-modificacion.component.ts